import axios, { AxiosResponse } from 'axios';

import { generalErrorLogging } from '.';
import schema from '../../build/openapiJsonSchema.json';

export const paperFormSchema = schema.definitions.paperOpts;
interface S2Response {
    title: string;
    authors: string;
    link: string;
    abstract: string;
    venue: string;
}
export const fetchPaperFromS2 = async (paperId: string): Promise<AxiosResponse<S2Response>> => {
    const s2Fields = ['url', 'title', 'abstract', 'venue', 'authors'];
    return axios
        .get(
            `https://api.semanticscholar.org/graph/v1/paper/${paperId}?fields=${s2Fields.join(',')}`
        )
        .then((result) => {
            const { title, authors, url, abstract, venue } = result.data;

            const formattedAuthors = authors
                .map((authorInfo: { authorId: number; name: string }) => authorInfo.name)
                .join(', ');

            // special request that if the venue is 'ArXiv' to make sure that the 'a' is lowercased for consistency
            const formattedVenue =
                (venue as string).toLocaleLowerCase() === 'arxiv' ? 'arXiv' : venue;

            const multiversePaper: S2Response = {
                title,
                authors: formattedAuthors,
                link: url,
                abstract,
                venue: formattedVenue,
            };
            return {
                ...result,
                data: multiversePaper,
            };
        })
        .catch((e) => generalErrorLogging(e));
};
